import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Container } from '../../../../components/HotelServices/components/Specials/components/Container.js';
import { getAllowedSpecials, hasCancellationRule } from '../../../../components/HotelServices/components/Specials/utils.js';
import { TourOperatorSpecial } from '../../../../components/TourOperatorSpecial/index.js';
export const Specials = ({
  specialInfo
}) => {
  const {
    hasCancellation,
    sortedSpecials
  } = useMemo(() => ({
    hasCancellation: hasCancellationRule(specialInfo),
    sortedSpecials: getAllowedSpecials(specialInfo)
  }), [specialInfo]);
  return _jsx(Container, {
    showSpacing: !hasCancellation,
    children: sortedSpecials.map((special, key) => _jsx(TourOperatorSpecial, {
      item: special,
      type: special.promotionType
    }, key))
  });
};